var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicMagnifierLight255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_1561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 212.495C174.441 212.495 212.495 174.441 212.495 127.5C212.495 80.5588 174.441 42.5053 127.5 42.5053C80.5588 42.5053 42.5054 80.5588 42.5054 127.5C42.5054 174.441 80.5588 212.495 127.5 212.495Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.812,
    cy: 84.4688,
    r: 37.25,
    fill: "#F2F2F2",
    stroke: "#B3B3B3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1256 38.3137C80.7838 38.3137 82.9388 36.1588 82.9388 33.5006C82.9388 30.8424 80.7838 28.6875 78.1256 28.6875C75.4674 28.6875 73.3125 30.8424 73.3125 33.5006C73.3125 36.1588 75.4674 38.3137 78.1256 38.3137Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.463 177.926C167.945 177.926 169.957 175.914 169.957 173.432C169.957 170.95 167.945 168.938 165.463 168.938C162.981 168.938 160.969 170.95 160.969 173.432C160.969 175.914 162.981 177.926 165.463 177.926Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3634 224.719L67.3678 233.182H57.375L62.3794 224.719H62.3634Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.218 116.499L130.334 125.153C130.462 125.36 130.302 125.631 130.063 125.631H119.847C119.608 125.631 119.449 125.36 119.576 125.153L124.692 116.499C124.82 116.292 125.123 116.292 125.234 116.499H125.218Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.899 153.223H234.488V149.812C234.488 148.936 233.771 148.219 232.895 148.219C232.018 148.219 231.301 148.936 231.301 149.812V153.223H227.906C227.03 153.223 226.312 153.94 226.312 154.817C226.312 155.693 227.03 156.411 227.906 156.411H231.317V159.821C231.317 160.698 232.034 161.415 232.911 161.415C233.787 161.415 234.504 160.698 234.504 159.821V156.411H237.915C238.792 156.411 239.509 155.693 239.509 154.817C239.509 153.94 238.792 153.223 237.915 153.223H237.899Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.911 91.6145V90.0226C197.911 88.7687 198.053 87.6837 198.338 86.7499C198.623 85.825 199.103 84.9445 199.779 84.1264C200.455 83.3082 201.371 82.4544 202.518 81.5562C203.701 80.6313 204.643 79.822 205.346 79.1461C206.048 78.4702 206.555 77.7943 206.867 77.1096C207.178 76.4248 207.338 75.6244 207.338 74.7173C207.338 73.2854 206.849 72.1916 205.879 71.4356C204.91 70.6886 203.541 70.3062 201.789 70.3062C200.232 70.3062 198.774 70.5285 197.404 70.9643C196.035 71.4001 194.683 71.9515 193.349 72.6096L191.25 68.154C192.789 67.3092 194.452 66.6333 196.257 66.1175C198.053 65.6017 200.037 65.3438 202.198 65.3438C205.648 65.3438 208.307 66.1797 210.193 67.8517C212.078 69.5236 213.021 71.7291 213.021 74.4683C213.021 75.9712 212.781 77.2607 212.309 78.3368C211.838 79.4129 211.135 80.4001 210.219 81.2983C209.294 82.2054 208.192 83.157 206.884 84.153C205.817 84.9979 205.008 85.7271 204.439 86.3408C203.87 86.9544 203.487 87.5769 203.274 88.1995C203.06 88.822 202.954 89.5779 202.954 90.4584V91.6234H197.911V91.6145ZM196.951 99.7696C196.951 98.3823 197.306 97.4129 198.027 96.8437C198.747 96.2746 199.627 95.9989 200.677 95.9989C201.726 95.9989 202.562 96.2835 203.283 96.8437C204.012 97.4129 204.376 98.3823 204.376 99.7696C204.376 101.157 204.012 102.1 203.283 102.696C202.553 103.291 201.691 103.594 200.677 103.594C199.663 103.594 198.747 103.291 198.027 102.696C197.306 102.1 196.951 101.121 196.951 99.7696Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0677 84.5803C62.8574 84.5803 71.6071 93.33 71.6071 104.12M79.9743 104.104C79.9743 119.516 67.4801 132.01 52.0677 132.01C36.6553 132.01 24.1611 119.516 24.1611 104.104C24.1611 88.6914 36.6553 76.1972 52.0677 76.1972C67.4801 76.1972 79.9743 88.6914 79.9743 104.104Z",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.359 175.711L123.739 164.332M88.1981 104.104C88.1981 124.058 72.022 140.234 52.0678 140.234C32.1136 140.234 15.9375 124.058 15.9375 104.104C15.9375 84.1495 32.1136 67.9734 52.0678 67.9734C72.022 67.9734 88.1981 84.1495 88.1981 104.104ZM73.7845 133.044L81.0759 125.753L85.1667 129.843L77.8753 137.135L73.7845 133.044ZM87.1962 127.815L127.744 168.363C130.877 171.496 130.888 176.601 127.744 179.745C124.611 182.878 119.506 182.89 116.362 179.745L75.814 139.198L87.1962 127.815Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.661 66.9375V76.9303M148.665 71.9419H138.656",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_1561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicMagnifierLight255);
export default __webpack_public_path__ + "static/media/graphic_magnifier-light-255.74f61a2bf9c446ca2189b7caf472c6f8.svg";
export { ForwardRef as ReactComponent };